(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ebook-store-button-250811"] && !Shopify.designMode) return;
  try {
    const links = document.querySelectorAll('.ebook__item a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebook-store-button-251011"] && !Shopify.designMode) return;
  try {
    const links = document.querySelectorAll('.ebook__item a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ebook-store-button"] && !Shopify.designMode) return;
  try {
    const links = document.querySelectorAll('.ebook__item a');
  for (let i = 0; i < links.length; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
  } catch(e) { console.error(e); }
})();

})();
